// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import { isProduction } from '@mairistem/tools';
import * as Sentry from '@sentry/react';
import pkg from '~/package.json';
import { getEnv } from './constants/environnement';

export const initialize = () => {
  if (isProduction()) {
    Sentry.init({
      dsn: 'https://85ec6e7fba6de40b613d4dace2be80f6@sentry.jvs-mairistem.dev/39',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.browserProfilingIntegration(),
        Sentry.replayIntegration({
          maskAllText: getEnv() === 'production',
          blockAllMedia: getEnv() === 'production',
        }),
      ],
      tracesSampleRate: 1.0,
      profilesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      release:
        getEnv() === 'development'
          ? `${pkg.name.replace(/^@[\w-]+(\.)?[\w-]+\//, '')}@dev`
          : `${pkg.name.replace(/^@[\w-]+(\.)?[\w-]+\//, '')}@${pkg.version}`,
      environment: getEnv(),
    });
  }

  // setupSentryAxiosInterceptor();
};

/**
 * Configure un intercepteur Axios pour synchroniser les headers X-User et X-Tenant avec Sentry
 */
// export const setupSentryAxiosInterceptor = () => {
// if (!isProduction()) {

// }

// request.interceptors.request.use((config) => {
//   const xUser = config.headers?.['X-User'] as string | undefined;
//   const xTenant = config.headers?.['X-Tenant'] as string | undefined;

//   if (xUser) {
//     const data = JSON.parse(xUser);

//     if (data.user) {
//       Sentry.setUser({
//         id: String(data?.id),
//         username: data?.username,
//         prenom: data?.prenom,
//         nom: data?.nom,
//         email: data?.email,
//       });
//     }
//   }

//   if (xTenant) {
//     const data = JSON.parse(xTenant);

//     if (data.tenant) {
//       Sentry.setTag('tenant.id', String(data?.id));
//       Sentry.setTag('tenant.nom', data?.nom);
//       Sentry.setTag('tenant.database', data?.database);
//     }
//   }

//   return config;
// });
// };

export default isProduction() ? Sentry : null;
